module.exports = __webpack_public_path__ + "static/media/hall-sph706-3.b73995b6.svg";